import BaseModule from './BaseModule'

// TODO: Harry: use observer or lozad
class Navbar extends BaseModule {
    constructor(o) {
        super(o);
        this.getDataObj({
            offset: $(window).height() - this.$el.height(),
            toggleClass: 'expanded'
        })
        this.addSubscribes('AppScroll');
        this.enable();
    }

    onAppScroll () {
        if (this.setProperty('state', Z.scrollY <= this.offset)) {
            this.$el.toggleClass(this.toggleClass, this.state);
        }
    }
}

export default Navbar
